<div class="cropContainer">
  <div class="fileInputContainer blueColorHover">
    <input type="file" name="file-5[]" id="file-5" class="fileInput" (change)="fileChangeEvent($event)">
    <label for="file-5">
      <div class="fileInputIcon"><i class="pi pi-upload"></i></div>
      <div>{{ 'select_file' | translate }}</div>
    </label>
  </div>

  <div class="cropper">
    <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [aspectRatio]="1 / 1"
        format="png"
        [canvasRotation]="imgRotation"
        [transform]="imgTransform"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"
    ></image-cropper>

    <div *ngIf="!noimage" class="imgOptions">
        <button (click)="imageTransform('rotate')"><i class="pi pi-refresh"></i></button>
        <button (click)="imageTransform('plus')"><i class="pi pi-search-plus"></i></button>
        <button (click)="imageTransform('minus')"><i class="pi pi-search-minus"></i></button>
        <button (click)="imageTransform('flipH')"><i class="pi pi-arrow-right"></i></button>
        <button (click)="imageTransform('flipV')"><i class="pi pi-arrow-up"></i></button>
    </div>

    <div *ngIf="noimage" class="noimage">
      <i class="pi pi-image"></i>
    </div>
  </div>
</div>




